import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AudioPlayerService } from './services/audio-player.service';

export interface audioInterface {
  src: string;
  title: string,
  thumbnail: string
}
@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styles: ``
})
export class AudioPlayerComponent implements OnInit {
  @ViewChild('audioElement') audioRef!: ElementRef<HTMLAudioElement>;

  isPlaying = false;
  isMuted = false;
  progress = 0;
  volume = 1;
  currentTime = 0;
  duration = 0;
  audioSrc !: string;
  thumbnail !: string;
  title !: string;

  constructor(private service: AudioPlayerService) { }
  ngOnInit(): void {
    this.service.PalyedAudioInfo.subscribe((data: audioInterface | null) => {
      if (data) {
        if (this.audioSrc) {
          this.audioSrc = "";
          this.currentTime = 0;
          this.duration = 0;
          this.progress = 0;
          setTimeout(() => {
            this.audioSrc = data.src;
            this.title = data.title;
            this.thumbnail = data.thumbnail;

            // const audio = this.audioRef.nativeElement;
            // audio.play();
            // this.isPlaying = true;
          }, 500);
        } else {
          this.audioSrc = data.src;
          this.title = data.title;
          this.thumbnail = data.thumbnail;
        }
      }
    })


  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    // const audio = this.audioRef.nativeElement;
    // audio.play();
    // this.isPlaying = true;
  }

  togglePlay() {
    const audio = this.audioRef.nativeElement;
    this.isPlaying ? audio.pause() : audio.play();
    this.isPlaying = !this.isPlaying;
  }

  updateProgress() {
    const audio = this.audioRef.nativeElement;
    this.currentTime = audio.currentTime;
    this.duration = audio.duration;
    this.progress = (audio.currentTime / audio.duration);
  }

  seekAudio(event: any) {
    const audio = this.audioRef.nativeElement;
    const seekTime = event * audio.duration;
    this.currentTime = seekTime;
    audio.currentTime = seekTime;
    this.progress = event;
  }

  loadMetadata() {
    const audio = this.audioRef.nativeElement;
    this.duration = audio.duration;
    audio.play();
    this.isPlaying = true;
  }

  changeVolume() {
    this.audioRef.nativeElement.volume = this.volume;
  }

  toggleMute() {
    this.isMuted = !this.isMuted;
    this.audioRef.nativeElement.muted = this.isMuted;
  }

  prevTrack() {
    // console.log('Previous track button clicked');
  }

  nextTrack() {
    // console.log('Next track button clicked');
  }
  formatTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);

    return `${hours ? (hours.toString().padStart(2, '0') + ':') : ''}${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  }

  closeAudio() {
    const audio = this.audioRef.nativeElement;
    audio.pause();
    this.service.setAudio(null);
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    const audio = this.audioRef.nativeElement;
    audio.pause();
    this.service.setAudio(null);
  }

}
